module.exports = __webpack_public_path__ + "img/digital_yuan.1ac4c3b5.png";